import metaApiClient from './meta-client';

export interface CommentAutoReplyTranslation {
    id: number;
    auto_reply_id: number;
    page_id: string;
    reply_message: string | null;
    dm_message: string | null;
    created_at?: string;
    updated_at?: string;
}

export interface CommentAutoReply {
    id: number;
    user_id: number;
    owner_name?: string | null; // só vem para admin
    page_ids: string[];
    name: string;
    reply_message: string;
    dm_message: string | null;
    like_comment: boolean;
    auto_translate: boolean;
    funnel_id: number | null;
    trigger_node_id: number | null;
    is_active: boolean;
    translations: CommentAutoReplyTranslation[];
    created_at?: string;
    updated_at?: string;
}

export interface CommentAutoReplyCreate {
    page_ids: string[];
    name: string;
    reply_message: string;
    dm_message?: string | null;
    like_comment: boolean;
    auto_translate: boolean;
    funnel_id?: number | null;
    trigger_node_id?: number | null;
    translations?: { page_id: string; reply_message?: string; dm_message?: string }[];
}

export interface CommentAutoReplyUpdate {
    page_ids?: string[];
    name?: string;
    reply_message?: string;
    dm_message?: string | null;
    like_comment?: boolean;
    auto_translate?: boolean;
    funnel_id?: number | null;
    trigger_node_id?: number | null;
    is_active?: boolean;
}

export interface CommentAutoReplyTranslationUpsert {
    page_id: string;
    reply_message?: string | null;
    dm_message?: string | null;
}

const BASE = '/meta/comment-auto-replies';

export const getCommentAutoReplies = async (userId?: number): Promise<CommentAutoReply[]> => {
    const response = await metaApiClient.get<CommentAutoReply[]>(BASE, { params: { user_id: userId } });
    return response.data;
};

export const getCommentAutoReply = async (id: number): Promise<CommentAutoReply> => {
    const response = await metaApiClient.get<CommentAutoReply>(`${BASE}/${id}`);
    return response.data;
};

export const createCommentAutoReply = async (data: CommentAutoReplyCreate): Promise<CommentAutoReply> => {
    const response = await metaApiClient.post<CommentAutoReply>(BASE, data);
    return response.data;
};

export const updateCommentAutoReply = async (id: number, data: CommentAutoReplyUpdate): Promise<CommentAutoReply> => {
    const response = await metaApiClient.patch<CommentAutoReply>(`${BASE}/${id}`, data);
    return response.data;
};

export const deleteCommentAutoReply = async (id: number): Promise<{ message: string }> => {
    const response = await metaApiClient.delete<{ message: string }>(`${BASE}/${id}`);
    return response.data;
};

export const upsertCommentAutoReplyTranslation = async (
    id: number,
    data: CommentAutoReplyTranslationUpsert
): Promise<CommentAutoReply> => {
    const response = await metaApiClient.put<CommentAutoReply>(`${BASE}/${id}/translations`, data);
    return response.data;
};

export const deleteCommentAutoReplyTranslation = async (
    id: number,
    pageId: string
): Promise<{ message: string }> => {
    const response = await metaApiClient.delete<{ message: string }>(`${BASE}/${id}/translations/${pageId}`);
    return response.data;
};
